import { ssoCookieClient } from '@/shared/lib/axios';

import {
  endSsoSession,
  selectExactPortalBearerToken,
  type SsoContext,
} from './ssoSession';

export const logoutSsoContext = async (context: SsoContext): Promise<string> => {
  const exactToken = selectExactPortalBearerToken(context, window.localStorage);

  return endSsoSession(
    context,
    async (endpoint, payload) => {
      const response = await ssoCookieClient.post(endpoint, payload, {
        withCredentials: true,
        headers: exactToken
          ? { Authorization: `Bearer ${exactToken}` }
          : undefined,
      });
      return response.data?.data;
    },
    window.sessionStorage,
  );
};
